// extracted by mini-css-extract-plugin
export default {"container":"riCKn","title":"N9B89","description":"_1Tmmq","descriptionText":"_1PEWS"};